import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { I18NextModule } from 'angular-i18next';
import { OrderService } from 'src/app/core/services/order.service';
import { RequestType } from 'src/app/shared/model/requestType.enum';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { User } from 'src/app/shared/model/user.model';
import { StorageService } from 'src/app/core/storage/storage.service';
import { MatDialog } from '@angular/material/dialog';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';
import i18next from 'i18next';
import { StepperComponent } from 'src/app/shared/components/stepper/stepper.component';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { DateAdapter, NativeDateAdapter } from '@angular/material/core';

export class CustomDateAdapter extends NativeDateAdapter {
  override getFirstDayOfWeek(): number {
    return 1;
  }
}
@Component({
  standalone: true,
  selector: 'app-transfers',
  templateUrl: './transfers.component.html',
  styleUrls: ['./transfers.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    StepperComponent
  ],
  providers: [{ provide: DateAdapter, useClass: CustomDateAdapter }]
})
export class TransfersComponent implements OnInit, AfterViewInit {
  requestTypeEnum = RequestType;
  controller = '';

  submitError = false;
  modalContent?: NgbModalRef;
  spinner = false;
  steps = new Map<string, boolean>();
  user!: User;
  landing2 = false;
  loading = false;

  constructor(
    private orderService: OrderService,
    public dialog: MatDialog,
    private storageService: StorageService,
    private navigationService: NavigationService
  ) {}

  ngOnInit(): void {
    this.landing2 = this.storageService.get('landing2') || false;
    this.storageService.set('navigation', 'newRequest');
    this.user = this.storageService.get('config');
    this.setSteps();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.navigationService.handleNavigationView('newRequest');
    }, 0);
  }

  onSelectionAuthorizers(event: { controller: string; authorizer: string }) {
    this.controller = event.controller;
  }

  sendRequest(newRequestData: any) {
    this.loading = true;
    const vinList = newRequestData.vins;
    const deliveryDate = newRequestData.requestInfo?.deliveryDate
      .toISOString()
      .split('T')[0];
    const returnDate = newRequestData.requestInfo?.returnDate
      .toISOString()
      .split('T')[0];
    const comments = newRequestData.comments;
    const controllerId = newRequestData.controller?.controller?.id;

    this.orderService
      .sendTransfers(vinList, deliveryDate, returnDate, controllerId, comments)
      .subscribe({
        next: () => {
          this.loading = false;
          this.dialog.open(FeedbackModalComponent, {
            data: {
              text: i18next.t('newRequestOk'),
              redirect: true,
              list: true,
              theme: 'ligth'
            }
          });
        },
        error: () => {
          this.loading = false;
          this.dialog.open(FeedbackModalComponent, {
            data: {
              text: i18next.t('newRequestKO'),
              close: true,
              theme: 'ligth'
            }
          });
        }
      });
  }

  setSteps() {
    this.steps.set('vehicle-finder', true);
    this.steps.set('approvers', true);
    this.steps.set('request-info', true);
    this.steps.set('car-config', false);
    this.steps.set('replacementvehicle', false);
    this.steps.set('additionalInfo', true);
  }
}
